export const DEFAULT_EMPTY_TERM = 'items'
